module.exports = __webpack_public_path__ + "static/assets/d6d90f088e0da7f6a02a310b96285c4a.svg";